/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Cacher 
  var nbProductImages = document.querySelectorAll('.shopify-section--product .product-single__media-slide').length;
  if ( nbProductImages > 4 ){
    document.querySelector(".shopify-section--product .product-single__media-slider").insertAdjacentHTML("afterend", '<span class="voir-plus active">Voir plus</span>');
    var voirPlusBtn = document.querySelector(".voir-plus");
    voirPlusBtn.onclick = function(event) {
      if ( voirPlusBtn.classList.contains("active") === true ){
        voirPlusBtn.textContent = "Voir moins";
        voirPlusBtn.classList.remove("active");
        document.head.insertAdjacentHTML('beforeend', '<style>@media only screen and (min-width: 1024px) {.product-single__media-slide:nth-child(n+5){display: block;}}</style>');
      }else{
        voirPlusBtn.textContent = "Voir plus";
        voirPlusBtn.classList.add("active");
        document.head.insertAdjacentHTML('beforeend', '<style>@media only screen and (min-width: 1024px) {.product-single__media-slide:nth-child(n+5){display: none;}}</style>');
      }
    };
  }







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
